// toastStore.ts
import { create } from "zustand";
const useToastStore = create((set, get) => ({
    toastRef: { current: null },
    setToastRef: (ref) => set({ toastRef: ref }),
    showToast: (severity, summary, detail, life = 2000) => {
        const toast = get().toastRef.current;
        if (toast) {
            toast.show({ severity, summary, detail, life });
        }
    },
}));
export default useToastStore;
